/**
 * Ayuda — Productos → Almacenes
 */

/** @type {import('../help-index.js').HelpSidebarItem} */
export const ADM_PRO_WAREHOUSES_ITEM = {
  id: 'warehouses',
  screenId: 'adm-pro-warehouses',
  label: 'Almacenes',
  description: 'Depósitos donde se guarda la mercadería.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro: 'Los almacenes (depósitos) son los lugares físicos donde se guarda el stock. Cada movimiento de mercadería se asocia a un almacén.',
      },
      {
        title: 'Ver la lista',
        bullets: [
          'Columnas: Código, Descripción, Estado (Activo/Inactivo).',
          'Interruptor «Solo activos» — muestra solo depósitos en uso.',
          'Tocá una fila para ver el detalle; el lápiz para editar.',
        ],
      },
      {
        title: 'Cargar un almacén nuevo',
        fields: [
          { label: 'Descripción', description: 'Nombre del depósito (por ejemplo «Depósito central»). Obligatorio.' },
          { label: 'Activo', description: 'Desmarcá para dejar de usarlo sin borrar historial.' },
          { label: 'Observaciones', description: 'Notas opcionales.' },
        ],
      },
      {
        title: 'Editar',
        intro: 'Mismos campos que en el alta. Guardá los cambios o cancelá.',
      },
    ],
  },
}
